module.exports = __webpack_public_path__ + "img/people.1302d05.jpg";